import { toast } from 'react-toastify';
import { requestComplete, requestError, requestStarted } from '../../core/actions/http-request';
import { doBuyTickets, doDeleteCartTickets, doRestoreCart, doSaveContactDetails, fetchCartTickets } from '../api/cart';
import { handleRequestErrors } from './forms';
import { decoratePayloadContactDetails, populateFields } from '../api/decorator';
import { closeModal, openModal } from '../../core/actions/modal';
import { CART_TICKETS_REQUEST_NAME } from '../api/config';
import { CONTACT_DETAILS_FORM_NAME } from '../reducers/features/contact-details';
import { CONTACT_DETAILS_MODAL } from '../../sell/constants/modal';

export const SET_CART_TICKETS = 'SET_CART_TICKETS';
export const setCartTickets = (payload) => ({
    type: SET_CART_TICKETS,
    payload,
});

export const DELETE_CART_TICKETS = 'DELETE_CART_TICKETS';
export const deleteCart = () => ({
    type: DELETE_CART_TICKETS,
});

export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const setErrorMessage = (errorMessage) => ({
    type: SET_ERROR_MESSAGE,
    payload: errorMessage,
});

export const SET_CART_REMAINING_TIME = 'SET_CART_REMAINING_TIME';
export const setCartRemainingTime = (remainingTime) => ({
    type: SET_CART_REMAINING_TIME,
    payload: remainingTime,
});

export const SET_CONTACT_DETAILS = 'SET_CONTACT_DETAILS';
export const setContactDetails = (contactDetails) => ({
    type: SET_CONTACT_DETAILS,
    payload: contactDetails,
});

export const getCartTickets = () => async (dispatch) => {
    try {
        dispatch(requestStarted(CART_TICKETS_REQUEST_NAME));
        const response = await fetchCartTickets();
        const formattedResponse = await response.json();
        const { data } = formattedResponse;
        dispatch(setCartTickets(data));
        if (data.contactDetails) {
            populateFields(CONTACT_DETAILS_FORM_NAME, data.contactDetails, dispatch);
        }
    } catch (e) {
        dispatch(requestError(CART_TICKETS_REQUEST_NAME));
    } finally {
        dispatch(requestComplete(CART_TICKETS_REQUEST_NAME));
    }
};
export const deleteCartTickets = () => async (dispatch) => {
    try {
        dispatch(requestStarted(CART_TICKETS_REQUEST_NAME));
        const response = await doDeleteCartTickets();
        const formattedResponse = await response.json();
        if (formattedResponse.status === 'error') {
            dispatch(setErrorMessage(formattedResponse.message));
            return;
        }
        dispatch(deleteCart());
    } catch (e) {
        dispatch(requestError(CART_TICKETS_REQUEST_NAME));
    } finally {
        dispatch(requestComplete(CART_TICKETS_REQUEST_NAME));
    }
};

export const saveContactDetails = (inputs, successCallback = null, getCartAfterwards = false) => async (dispatch) => {
    const payload = decoratePayloadContactDetails(inputs);
    const response = await doSaveContactDetails(payload);
    const formattedResponse = await response.json();
    if (formattedResponse.status === 'error') {
        handleRequestErrors(CONTACT_DETAILS_FORM_NAME, formattedResponse, dispatch);
        dispatch(openModal(CONTACT_DETAILS_MODAL));
        return;
    }

    dispatch(setContactDetails(payload));
    if (successCallback) {
        successCallback();
    }
    if (getCartAfterwards) {
        dispatch(getCartTickets());
    }
    dispatch(closeModal(CONTACT_DETAILS_MODAL));
};

export const buyTickets = () => async () => {
    const response = await doBuyTickets();
    const formattedResponse = await response.json();
    if (formattedResponse.status === 'success') {
        window.location = formattedResponse.data.redirectUrl;
    }
    toast.error(formattedResponse.message);
};

export const restoreCart = () => async (dispatch) => {
    const response = await doRestoreCart();
    const formattedResponse = await response.json();
    if (formattedResponse.status === 'success') {
        dispatch(getCartTickets());
    }
    toast.error(formattedResponse.message);
};
